import { DisplayMode } from '@flywire/internal-components/model';

import { ENDPOINTS } from '../../endpoints';

export type DocumentCollectorUrlBuilderParams = {
  collectionId: string;
  collectionToken: string;
  displayMode?: DisplayMode;
  detectDuplicateFiles?: boolean;
};

export const documentCollectorUrlBuilder = (params: DocumentCollectorUrlBuilderParams): string => {
  const {
    collectionId,
    collectionToken,
    displayMode = 'full-screen',
    detectDuplicateFiles
  } = params;

  let url = `${ENDPOINTS.documentCollectionForm}?collection_id=${encodeURIComponent(collectionId)}&collection_token=${encodeURIComponent(collectionToken)}&display_mode=${encodeURIComponent(displayMode)}`;

  if (detectDuplicateFiles === true) {
    url += '&detect_duplicate_files=true';
  }

  return url;
};
